import { Button, Container, Section, Eyebrow, Display, SEO } from "./ui";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page not found — WhoBrew"
        description="This page doesn't exist or has moved. Head back home or contact us."
        noindex
      />
      <Section tone="page" spacing="loose">
        <Container width="prose" className="text-center">
          <Eyebrow>404</Eyebrow>
          <Display as="h1" scale="lg" italicWord="exist" className="mt-5">
            This page doesn't exist.
          </Display>
          <p className="mt-7 text-lg text-coffee-700 dark:text-cream-200 max-w-md mx-auto">
            The link may be broken, or the page may have moved. Head home or get in touch.
          </p>
          <div className="mt-10 flex justify-center gap-4 flex-wrap">
            <Button to="/" size="lg">Back home</Button>
            <Button to="/contact" variant="secondary" size="lg">Contact us</Button>
          </div>
        </Container>
      </Section>
    </>
  );
}
